import { CalendarMonth, Close } from "@mui/icons-material";
import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import { endOfDay, startOfDay, startOfMonth, startOfYear, subDays } from "date-fns";
import { fr } from "date-fns/locale";
import moment from "moment";
import { useState } from "react";
import { DateRangePicker, createStaticRanges } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./dateRangeFilter.css";

const STATIC_RANGES = createStaticRanges([
  {
    label: "Aujourd'hui",
    range: () => ({ startDate: startOfDay(new Date()), endDate: endOfDay(new Date()) }),
  },
  {
    label: "7 derniers jours",
    range: () => ({ startDate: startOfDay(subDays(new Date(), 6)), endDate: endOfDay(new Date()) }),
  },
  {
    label: "30 derniers jours",
    range: () => ({ startDate: startOfDay(subDays(new Date(), 29)), endDate: endOfDay(new Date()) }),
  },
  {
    label: "Ce mois-ci",
    range: () => ({ startDate: startOfMonth(new Date()), endDate: endOfDay(new Date()) }),
  },
  {
    label: "Cette année",
    range: () => ({ startDate: startOfYear(new Date()), endDate: endOfDay(new Date()) }),
  },
]);

const DateRangeFilter = ({ startDate, endDate, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const ranges = [{ startDate, endDate, key: "selection" }];

  return (
    <Box>
      <Button
        variant="outlined"
        size="small"
        className="dateRangeTrigger"
        startIcon={<CalendarMonth fontSize="small" className="dateRangeTriggerIcon" />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {moment(startDate).format("DD/MM/YYYY")} — {moment(endDate).format("DD/MM/YYYY")}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "var(--profile-radius)", border: "1px solid var(--profile-border)", boxShadow: "0 12px 32px rgba(21, 26, 52, 0.18)" } }}
      >
        <Box className="dateRangePanel">
          <Box className="dateRangePanelHeader">
            <IconButton size="small" className="dateRangeCloseButton" onClick={() => setAnchorEl(null)}>
              <Close fontSize="small" />
            </IconButton>
            <CalendarMonth className="dateRangePanelTitleIcon" />
            <Typography className="dateRangePanelTitle">Sélectionner la période</Typography>
          </Box>

          <DateRangePicker
            onChange={(item) => onChange(item.selection.startDate, item.selection.endDate)}
            moveRangeOnFirstSelection={false}
            ranges={ranges}
            locale={fr}
            maxDate={new Date()}
            staticRanges={STATIC_RANGES}
            inputRanges={[]}
            rangeColors={["#4f46e5"]}
            months={1}
            direction="horizontal"
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default DateRangeFilter;
